import { matchPath } from "react-router-dom";

const matchSoldPage = () =>
  matchPath(window.location.pathname, {
    path: "/sold",
  });

export default matchSoldPage;
